

import axios, { AxiosError } from 'axios';
import { API_URL } from '../../const/const';

export const getAllDevices = async (SmartDVRToken: string, userLogin: string) => {
    console.info('[API:getAllDevices] start', { userLogin });

    if (!userLogin || !SmartDVRToken) {
        console.error('[API:getAllDevices] запрос не отправлен: отсутствуют userLogin или SmartDVRToken');
        return [];
    }

    try {
        const response = await axios.get(
            API_URL,
            {
                headers: {
                    SmartDVRLogin: userLogin,
                    SmartDVRToken: SmartDVRToken,
                },
            });
        const count = Array.isArray(response?.data) ? response.data.length : undefined;
        console.info('[API:getAllDevices] success', { count });
        return response.data;
    } catch (error) {
        const err = error as AxiosError;
        const status = err.response?.status;
        const statusText = err.response?.statusText;
        const axiosCode = err.code;
        const data: any = err.response?.data;
        const serverCode = typeof data === 'object' ? (data?.code ?? data?.errorCode ?? data?.status ?? data?.statusCode ?? data?.error?.code) : undefined;
        console.error('[API:getAllDevices] ошибка', {
            status,
            statusText,
            axiosCode,
            serverCode,
            message: err.message,
            data,
        });
        return [];
    }
};